var _defs, _rect, _path, _circle, _clipPath, _path2, _g, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrazil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 504,
    width: 720,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-2100 -1470 4200 2940"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "brazil_svg__i",
    fillRule: "evenodd",
    d: "M-31.5 0h33a30 30 0 0030-30v-10a30 30 0 00-30-30h-33zm13-13h19a19 19 0 0019-19v-6a19 19 0 00-19-19h-19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brazil_svg__j",
    transform: "translate(-31.5)",
    d: "M0 0h63v-13H12v-18h40v-12H12v-14h48v-13H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brazil_svg__l",
    d: "M-26.25 0h52.5v-12h-40.5v-16h33v-12h-33v-11H25v-12h-51.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brazil_svg__k",
    d: "M-31.5 0h12v-48l14 48h11l14-48V0h12v-70H14L0-22l-14-48h-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brazil_svg__a",
    fillRule: "evenodd",
    d: "M0 0a31.5 35 0 000-70A31.5 35 0 000 0m0-13a18.5 22 0 000-44 18.5 22 0 000 44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brazil_svg__c",
    fillRule: "evenodd",
    d: "M-31.5 0h13v-26h28a22 22 0 000-44h-40zm13-39h27a9 9 0 000-18h-27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brazil_svg__n",
    d: "M-15.75-22C-15.75-15-9-11.5 1-11.5s14.74-3.25 14.75-7.75c0-14.25-46.75-5.25-46.5-30.25C-30.5-71-6-70 3-70s26 4 25.75 21.25H13.5c0-7.5-7-10.25-15-10.25-7.75 0-13.25 1.25-13.25 8.5-.25 11.75 46.25 4 46.25 28.75C31.5-3.5 13.5 0 0 0c-11.5 0-31.55-4.5-31.5-22z"
  }), /*#__PURE__*/React.createElement("use", {
    id: "brazil_svg__o",
    xlinkHref: "#brazil_svg__f",
    transform: "scale(31.5)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "brazil_svg__p",
    xlinkHref: "#brazil_svg__f",
    transform: "scale(26.25)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "brazil_svg__r",
    xlinkHref: "#brazil_svg__f",
    transform: "scale(21)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "brazil_svg__q",
    xlinkHref: "#brazil_svg__f",
    transform: "scale(15)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "brazil_svg__s",
    xlinkHref: "#brazil_svg__f",
    transform: "scale(10.5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "brazil_svg__m"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "brazil_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-31.5 0v-70h63V0zM0-47v12h31.5v-12z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#brazil_svg__a",
    clipPath: "url(#brazil_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5-35h26.5v10H5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5-35h10V0h-10z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "brazil_svg__h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#brazil_svg__c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 0c0-10 0-32-15-32H-6c22 0 22 22 22 32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "brazil_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "brazil_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "brazil_svg__d",
    transform: "rotate(18 0 -1)",
    d: "M0-1v1h.5"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#brazil_svg__d",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#brazil_svg__e",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#brazil_svg__e",
    transform: "rotate(-72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#brazil_svg__e",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#brazil_svg__e",
    transform: "rotate(216)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: "-50%",
    x: "-50%",
    height: "100%",
    fill: "#009b3a",
    width: "100%"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1743 0L0 1113 1743 0 0-1113z",
    fill: "#fedf00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 735,
    fill: "#002776"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "brazil_svg__g"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 735
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-2205 1470a1785 1785 0 013570 0h-105a1680 1680 0 10-3360 0z",
    clipPath: "url(#brazil_svg__g)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-420 1470)",
    fill: "#009b3a"
  }, /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#brazil_svg__a",
    transform: "rotate(-7)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#brazil_svg__h",
    transform: "rotate(-4)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#brazil_svg__i",
    transform: "rotate(-1)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#brazil_svg__j",
    transform: "rotate(2)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#brazil_svg__k",
    transform: "rotate(5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#brazil_svg__l",
    transform: "rotate(9.75)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#brazil_svg__c",
    transform: "rotate(14.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#brazil_svg__h",
    transform: "rotate(17.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#brazil_svg__a",
    transform: "rotate(20.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#brazil_svg__m",
    transform: "rotate(23.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#brazil_svg__h",
    transform: "rotate(26.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#brazil_svg__j",
    transform: "rotate(29.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#brazil_svg__n",
    transform: "rotate(32.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#brazil_svg__n",
    transform: "rotate(35.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#brazil_svg__a",
    transform: "rotate(38.5)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    y: -132,
    x: -600,
    xlinkHref: "#brazil_svg__o"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    y: 177,
    x: -535,
    xlinkHref: "#brazil_svg__o"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    y: 243,
    x: -625,
    xlinkHref: "#brazil_svg__p"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    y: 132,
    x: -463,
    xlinkHref: "#brazil_svg__q"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    y: 250,
    x: -382,
    xlinkHref: "#brazil_svg__p"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    y: 323,
    x: -404,
    xlinkHref: "#brazil_svg__r"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    y: -228,
    x: 228,
    xlinkHref: "#brazil_svg__o"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    y: 258,
    x: 515,
    xlinkHref: "#brazil_svg__o"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    y: 265,
    x: 617,
    xlinkHref: "#brazil_svg__r"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    y: 323,
    x: 545,
    xlinkHref: "#brazil_svg__p"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    y: 477,
    x: 368,
    xlinkHref: "#brazil_svg__p"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    y: 551,
    x: 367,
    xlinkHref: "#brazil_svg__r"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    y: 419,
    x: 441,
    xlinkHref: "#brazil_svg__r"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    y: 382,
    x: 500,
    xlinkHref: "#brazil_svg__p"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    y: 405,
    x: 365,
    xlinkHref: "#brazil_svg__r"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    y: 30,
    x: -280,
    xlinkHref: "#brazil_svg__p"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    y: -37,
    x: 200,
    xlinkHref: "#brazil_svg__r"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    y: 330,
    xlinkHref: "#brazil_svg__o"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    y: 184,
    x: 85,
    xlinkHref: "#brazil_svg__p"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    y: 118,
    xlinkHref: "#brazil_svg__p"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    y: 184,
    x: -74,
    xlinkHref: "#brazil_svg__r"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    y: 235,
    x: -37,
    xlinkHref: "#brazil_svg__q"
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    y: 495,
    x: 220,
    xlinkHref: "#brazil_svg__p"
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    y: 430,
    x: 283,
    xlinkHref: "#brazil_svg__r"
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    y: 412,
    x: 162,
    xlinkHref: "#brazil_svg__r"
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    y: 390,
    x: -295,
    xlinkHref: "#brazil_svg__o"
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    y: 575,
    xlinkHref: "#brazil_svg__s"
  })));
}
export default __webpack_public_path__ + "assets/static/media/brazil.5c5f5fbb.svg";
export { SvgBrazil as ReactComponent };